import { useState } from "react";
import { BadgeCheck, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const EMPTY = { name: "", email: "", company: "", role: "", message: "" };

export const SponsorSlot = ({ sponsor, articleSlug }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!sponsor) return null;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leads", { ...form, sponsor_id: sponsor.id, article_slug: articleSlug });
      setDone(true);
      toast.success(`Your request has been sent to ${sponsor.name}.`);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };

  return (
    <div data-testid="sponsor-slot" className="border border-[#DADADA] bg-white">
      <div className="bg-[#F6F6F6] px-5 py-2 flex items-center justify-between">
        <span className="overline !text-[9px] text-[#E5332A]">{sponsor.tier_label}</span>
        <BadgeCheck size={14} className="text-[#E5332A]" />
      </div>
      <div className="p-5">
        <p className="font-display text-lg font-bold" data-testid="sponsor-name">{sponsor.name}</p>
        <p className="text-xs text-[#E5332A] mt-1">{sponsor.tagline}</p>
        <p className="text-sm text-[#575757] mt-3 leading-relaxed">{sponsor.description}</p>
        {done ? (
          <p data-testid="sponsor-lead-success" className="mt-5 text-sm bg-[#F6F6F6] p-3 text-[#E5332A]">Thank you. {sponsor.name} will be in touch within two working days.</p>
        ) : !open ? (
          <button data-testid="sponsor-lead-open-btn" onClick={() => setOpen(true)} className="mt-5 w-full flex items-center justify-between bg-[#0A0A0A] text-white px-4 py-3 text-sm hover:bg-[#E5332A] transition-colors">
            {sponsor.cta_label} <ArrowRight size={14} />
          </button>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-2" data-testid="sponsor-lead-form">
            <Input data-testid="sponsor-lead-name" required placeholder="Full name" value={form.name} onChange={set("name")} className="rounded-none" />
            <Input data-testid="sponsor-lead-email" required type="email" placeholder="Work email" value={form.email} onChange={set("email")} className="rounded-none" />
            <Input data-testid="sponsor-lead-company" placeholder="Company" value={form.company} onChange={set("company")} className="rounded-none" />
            <Input data-testid="sponsor-lead-role" placeholder="Role" value={form.role} onChange={set("role")} className="rounded-none" />
            <Textarea data-testid="sponsor-lead-message" placeholder="What would you like to discuss?" value={form.message} onChange={set("message")} className="rounded-none" rows={3} />
            <button data-testid="sponsor-lead-form-submit" disabled={busy} className="w-full bg-[#0A0A0A] text-white px-4 py-3 text-sm hover:bg-[#E5332A] transition-colors">
              {busy ? "Sending…" : "Send request"}
            </button>
            <p className="text-[10px] text-[#575757]">Your details are shared only with {sponsor.name}.</p>
          </form>
        )}
      </div>
    </div>
  );
};
